import "bootstrap/dist/css/bootstrap.min.css";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NavbarLinks } from "../../../../../../ds";
import { IProductDataItems } from "../../../../business/core";
import { ProductPageControllerImpl } from "../../../../business/index.js";
import { AdditionalProducts, ProductAdvertiser, ProductHero, ProductInformation } from "./";

export const ProductItem: React.FC<{ data: IProductDataItems }> = ({ data }) => {
    const { t } = useTranslation('product');

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(true);

    const { phoneCode: initialPhoneCode, phoneNumber: initialPhoneNumber } = data.main.advertiser_phone;
    const [advertiserPhoneCode, setAdvertiserPhoneCode] = useState(initialPhoneCode);
    const [advertiserPhone, setAdvertiserPhone] = useState(initialPhoneNumber);

    const handleShowPhoneNumber = useCallback(async () => {
        if (!isLoading) {
            setLoading(true);
            try {
                const controller = new ProductPageControllerImpl();
                const response = await controller.requestPhoneNumber(data.main.url);

                const { phoneCode, phoneNumber } = response;

                setShowButton(false);
                setAdvertiserPhoneCode(phoneCode);
                setAdvertiserPhone(phoneNumber);
            } finally {
                setLoading(false);
            }
        }
    }, [data.main.productId, isLoading]);

    useEffect(() => {
        const { phoneCode, phoneNumber } = data.main.advertiser_phone;
        setAdvertiserPhoneCode(phoneCode);
        setAdvertiserPhone(phoneNumber);
        setShowButton(true);
    }, [data.main.advertiser_phone])

    useEffect(() => {
        window.addEventListener(
            "resize",
            () => {
                const ismobile = window.innerWidth < 992;
                if (ismobile !== isMobile) {
                    setIsMobile(ismobile);
                }
            },
            false
        );
    }, [isMobile]);

    return (
        <>
            <Row className={"d-none d-lg-block"}>
                <Col xs={12} sm={12} md={12} lg={12} xxl={9}>
                    <NavbarLinks activeKey={0} />
                </Col>
            </Row>

            <ProductHero
                isMobile={isMobile}
                images={data.main.images}
                data={data.main}
                details={t('moreInformations')}
                shippingDescription={t('shippingDescription')}
            />

            <ProductInformation
                isMobile={isMobile}
                dataInformations={data.main.informations}
                informationTitle={t('informationTitle')}
            />

            <ProductAdvertiser
                advertiser={
                    {
                        tradeName: data.main.advertiser,
                        phone: advertiserPhone,
                        phoneCode: advertiserPhoneCode,
                        location: data.main.advertiser_location,
                        image: data.main.advertiser_image
                    }
                }
                price={data.main.value}
                handleEngagement={handleShowPhoneNumber}
                isLoading={isLoading}
                showButton={showButton}
                isMobile={isMobile}
            />

            <AdditionalProducts data={data.secondary} isMobile={false} translate={t} />
        </>
    );
}
